export const sr = {
    nav: {
        home: "Početna",
        about: "O nama",
        services: "Usluge",
        projects: "Projekti",
        contact: "Kontakt",
    },
    hero: {
        title: "NOPA Engineering",
        subtitle: "PORTFOLIO",
        description: "Precizno projektovanje savremenih konstrukcija.\nOd ideje do pouzdane realizacije.",
        role: "ALIJA KOLAKOVIĆ, mast. inž. građ.",
        position: "Direktor / Glavni projektant",
        address: "Mitrovačka 66, 36300 Novi Pazar, Srbija",
        viewProjects: "Pogledajte projekte",
        contactUs: "Kontaktirajte nas",
    },
    about: {
        title: "O nama",
        description: "NOPA Engineering je profesionalni projektni biro iz oblasti građevinarstva, koji vodi licencirani građevinski inženjer Alija Kolaković, mast. inž. građ. Biro je usmeren na kvalitet, preciznost i savremeno projektovanje konstrukcija, sa iskustvom na projektima stambenih i poslovnih objekata, kao i složenijih infrastrukturnih i urbanih sadržaja.",
        mission: "Naš rad objedinjuje stručno znanje iz oblasti konstrukcija, razumevanje arhitektonskog koncepta i izradu kompletne tehničke dokumentacije, sa ciljem postizanja održivih, sigurnih i ekonomski opravdanih rešenja za investitore i partnere.",
        areasTitle: "Oblasti rada:",
        areas: [
            "Projektovanje armiranobetonskih konstrukcija",
            "Statički proračuni i detaljna tehnička dokumentacija",
            "Stambeni, poslovni i urbani objekti",
            "Projekti usklađeni sa Evrokodom",
            "Tehnička podrška i kontrola rešenja tokom realizacije objekta"
        ],
        experience: "Iskustvo",
        projects: "Projekata",
        clients: "Klijenata",
        years: "Godina"
    },
    services: {
        title: "Naše usluge",
        description: "Pružamo celokupni spektar građevinsko-inženjerskih usluga, prilagođenih specifičnim zahtevima i izazovima svakog projekta, od projektovanja i statičkih proračuna do tehničke podrške i kontrole rešenja tokom izvođenja radova.",
        items: [
            {
                title: "1. Projektovanje konstrukcija",
                details: "Stambeni, poslovni, industrijski i urbani objekti"
            },
            {
                title: "2. Statički proračuni",
                details: "Armiranobetonske konstrukcije\nProračuni u skladu sa Evrokodom"
            },
            {
                title: "3. Planovi oplate i armature",
                details: "Planovi oplate i armature koji prate potrebe tržišta širom Evrope i severne Afrike, sa posebnim akcentom na ključne industrijske regione i lokalne standarde."
            },
            {
                title: "4. Tehnička kontrola i podrška",
                details: "Saradnja kao spoljašnji saradnik na gradilištu\nKontrola izvedenih elemenata i savetodavne usluge tokom izvođenja"
            },
            {
                title: "5. Konsultantske usluge",
                details: "Revizija projekta\nSaveti u ranoj fazi projektovanja\nOptimizacija tehničkih rešenja"
            },
            {
                title: "6. Izrada plana upravljanja otpadom",
                details: "Planiranje i dokumentacija u skladu sa zahtevima gradilišta"
            },
            {
                title: "7. Predmer i predračun radova",
                details: "Priprema predmera i predračuna za različita tržišta: Nemačka, Srbija\nIzrada kalkulacija i situacija za naplatu i kontrolu troškova"
            }
        ]
    },
    contact: {
        title: "Kontakt",
        getInTouch: "Stupite u kontakt",
        description: "Spremni za vaš sledeći projekat? Kontaktirajte nas za konsultacije ili ponudu. Tu smo da odgovorimo na sva vaša pitanja.",
        visitUs: "Posetite nas",
        emailUs: "Pošaljite nam email",
        callUs: "Pozovite nas",
        firstName: "Ime",
        lastName: "Prezime",
        email: "Email adresa",
        message: "Poruka",
        sendMessage: "Pošalji poruku",
        placeholderGeneric: "Unesite...",
        placeholderMessage: "Recite nam nešto o vašem projektu...",
        success: "Poruka je uspešno poslata! Javićemo vam se uskoro.",
        error: "Došlo je do greške prilikom slanja. Molimo pokušajte ponovo.",
        sending: "Slanje..."
    },
    portfolio: {
        title: "Istaknuti projekti",
        description: "Prikaz naše inženjerske izvrsnosti i posvećenosti kvalitetu kroz različite sektore.",
        loading: "Učitavanje projekata...",
        viewDetails: "Pogledaj detalje",
        viewAll: "Pogledaj sve projekte",
        overview: "Pregled projekta",
        structuralAnalysis: "Detaljna statička analiza i projektovanje su izvršeni kako bi se osigurali najviši standardi sigurnosti i arhitektonskog integriteta. Naš tim je blisko sarađivao sa arhitektama i izvođačima kako bi se projekat realizovao na vreme i u okviru budžeta.",
        details: "Detalji projekta",
        location: "Lokacija",
        year: "Godina",
        client: "Klijent",
        status: "Status"
    },
    footer: {
        rights: "Sva prava zadržana."
    }
};
